export enum ConversionType{
   saleorder_to_saleorder = 'Salerorder to Saleorder',
    saleorder_to_bulk = 'Saleorder to Bulk',
    // bulk_to_saleorder = 'Bulk to Saleorder',
    // bulk_to_bulk = 'Bulk to Bulk'
}